// extracted by mini-css-extract-plugin
export default {"card":"styles_card__3+HIr","card__left":"styles_card__left__0jo4g","card__right":"styles_card__right__bAHDb"};